<template>
    <el-select filterable clearable v-model="selected">
        <el-option v-for="i in list" :key="i.value" :label="i.name" :value="i.value"></el-option>
    </el-select>
</template>
<script>
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';

    export default {
        data: function () {
            return {
                selected: this.value,
                list: [
                    {
                        name: 'Con observaciones',
                        value: 'rechazado'
                    },
                    {
                        name: 'En revisión',
                        value: 'en_revision'
                    }
                ]
            };
        },
        props: ['value'],
        components: {
            ElSelect,
            ElOption
        },
        watch: {
            selected: function (value) {
                this.$emit('input', value);
            },
            value: function (value) {
                this.selected = value;
            }
        }
    }
</script>